/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { getAccessToken } from "@lib/shared/cookies";
import { ServerRequest } from "@genericTypes/sharedTypes";
import HTTP, { apiHandler } from "@services/http.service";
import { AxiosRequestConfig } from "axios";

export interface ZipCodeSearchResponse {
    success: boolean;
    data: ZipCodeSearch[] | null;
}

export interface ZipCodeSearch {
    zipCode: string;
    stateCode: string;
    city: string;
}

export const getZipCodeSuggestions = async ({
    req,
    zipCode,
}: {
    zipCode: string;
    req?: ServerRequest;
}): Promise<{
    data: ZipCodeSearch[];
    error: Error | null;
}> => {
    const accessToken = req ? req.accessToken : getAccessToken();

    const config: AxiosRequestConfig = {
        method: "get",
        url: req
            ? `/validation/api/v1/lookups/zipcode/search?q=${zipCode}`
            : `/api/zipCodeSearch/${zipCode}`,
        headers: {
            "X-DOMAIN-NAME": `${process.env.NEXT_PUBLIC_X_DOMAIN as string}`,
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken as string}`,
            // "X-Language": req ? req.locale ?? "en" : getLocale(),
            "X-Language": "en",
        },
    };

    if (req) {
        const { data: zipCodeSearchResponse, error } =
            await apiHandler<ZipCodeSearchResponse>(() => HTTP.server(config));

        return {
            //@ts-ignore
            data: zipCodeSearchResponse?.data ?? null,
            error,
        };
    } else {
        const { data, error } = await apiHandler<ZipCodeSearchResponse>(() =>
            HTTP.client(config),
        );
        return {
            //@ts-ignore
            data: data ?? null,
            error,
        };
    }
};
